export default __webpack_public_path__ + "static/media/mt4_android.fbe341d2.png";